<script>
import { BFormGroup, BFormInput, BInputGroup, BInputGroupAppend, BInputGroupText } from 'bootstrap-vue'

export default {
    components: { BFormGroup, BFormInput, BInputGroup, BInputGroupAppend, BInputGroupText },
    props: {
        readOnly: {
            type: Boolean,
            default: false,
        },
        value: {
            default: null,
        },
        config: {
            type: Object,
            default() {
                return {
                    properties: {},
                };
            }
        }
    },
    data() {
        return {
            componentValue: this.extractNumericValue(this.value),
        };
    },
    watch: {
        value(newValue) {
            this.componentValue = this.extractNumericValue(newValue);
        }
    },
    computed: {
        propsConfig() {
            return this.config && this.config.properties ? this.config.properties : {};
        },
        label() {
            if (this.propsConfig.label) {
                return this.$t(this.propsConfig.label);
            }
            return this.config.type || '';
        },
        placeholder() {
            return this.propsConfig.placeholder ? this.$t(this.propsConfig.placeholder) : '';
        },
        required() {
            return this.propsConfig.required === true;
        },
        min() {
            return this.propsConfig.min !== undefined ? this.propsConfig.min : undefined;
        },
        max() {
            return this.propsConfig.max !== undefined ? this.propsConfig.max : undefined;
        },
        step() {
            return this.propsConfig.step !== undefined ? this.propsConfig.step : undefined;
        },
        precision() {
            return this.propsConfig.precision !== undefined ? this.propsConfig.precision : undefined;
        },
        unit() {
            if (this.value && typeof this.value === 'object' && this.value.unit !== undefined) {
                return this.value.unit;
            }
            return this.propsConfig.unit || '';
        },
        hasValue() {
            return this.componentValue !== null
                && this.componentValue !== undefined
                && this.componentValue !== '';
        },
        mandatoryClass() {
            return this.required && !this.hasValue ? 'input-bg-warning' : '';
        },
        readOnlyValue() {
            if (!this.hasValue) {
                return '-';
            }

            const numericValue = Number(this.componentValue);
            if (Number.isNaN(numericValue)) {
                return this.componentValue;
            }

            if (Number.isInteger(this.precision) && this.precision >= 0) {
                return numericValue.toFixed(this.precision);
            }

            return numericValue;
        }
    },
    methods: {
        extractNumericValue(value) {
            if (value && typeof value === 'object' && value.value !== undefined) {
                return value.value;
            }
            return value;
        },
        onInput(value) {
            if (value === '' || value === null || value === undefined) {
                this.$emit('input', {
                    value: null,
                    unit: this.unit,
                });
                return;
            }

            const parsed = parseFloat(value);
            this.$emit('input', {
                value: Number.isNaN(parsed) ? null : parsed,
                unit: this.unit,
            });
        }
    }
}
</script>

<template>
    <div>
        <div v-if="readOnly">
            <h5>{{ label }}</h5>
            <div class="mb-1">{{ readOnlyValue }}{{ unit ? ` ${unit}` : '' }}</div>
        </div>
        <b-form-group
            v-else
            :label="label"
        >
            <b-input-group>
                <b-form-input
                    v-model="componentValue"
                    :class="mandatoryClass"
                    type="number"
                    :min="min"
                    :max="max"
                    :step="step"
                    :placeholder="placeholder"
                    @input="onInput"
                />
                <b-input-group-append v-if="unit">
                    <b-input-group-text>{{ unit }}</b-input-group-text>
                </b-input-group-append>
            </b-input-group>
        </b-form-group>
    </div>
</template>
